import React from "react";

import { ScoreLabel } from "consts";
import { useResponse } from "screens/question/hooks";
import {
  Container,
  Wrapper,
  RatingButtons,
  RatingButton,
  NumberText,
  ScoreDescription,
  DescriptionText,
  DescriptionLine,
} from "./styled";

export const ScoreQuestion = ({ question, section }) => {
  const { options, RTL, selectOption, selectedOptions } = useResponse(question);

  const firstLastIndices = [0, question.options.length - 1];
  const hasDescription = firstLastIndices.some(
    index => question.options[index].other_text_placeholder,
  );

  const reorientedOptions = reorientOptions(options, RTL);

  const largeRatingButtons = question.options.length < 8;

  return (
    <Container
      $hasDescription={hasDescription}
      $compact={section.questions.length > 1}
    >
      <Wrapper>
        {reorientedOptions.map((option, index) => {
          const isSelected = selectedOptions[option.virtual_id];
          return (
            <RatingButtons
              $index={index}
              key={option.id}
              $isSelected={isSelected}
              $large={largeRatingButtons}
            >
              <RatingButton onPress={() => selectOption(option)}>
                <NumberText $isSelected={isSelected}>{option.text}</NumberText>
              </RatingButton>
              {firstLastIndices.includes(index) &&
                !!option.other_text_placeholder && (
                  <ScoreDescription>
                    <DescriptionLine />
                    <DescriptionText>
                      {translateDescription(option, RTL)}
                    </DescriptionText>
                  </ScoreDescription>
                )}
            </RatingButtons>
          );
        })}
      </Wrapper>
    </Container>
  );
};

export const translateDescription = (option, RTL) => {
  if (!RTL) {
    return option.other_text_placeholder;
  }

  if (option.score === ScoreLabel.NEGATIVE) {
    return "بلکل نہیں";
  }
  if (option.score === ScoreLabel.POSITIVE) {
    return "جی ضرور";
  }

  return option.other_text_placeholder;
};

const reorientOptions = (options, isRTL) =>
  isRTL ? [...options].reverse() : options;
